<main class="circle-gradient-1">
  <section class="breadcrumb-sec event-sec">
      <div class="container">
        <div class="row g-0">
            <div class="col-lg-6 col-md-6">
                <ul class="breadcrumb">
                    <li><a routerLink="/">Home</a></li>
                    <li><i class="fa fa-angle-right"></i></li>
                    <li><a href="events">Events</a></li>
                    <li><i class="fa fa-angle-right"></i></li>
                    <li><a routerLink="/events" fragment="conferences">Conferences</a></li>
                    <li><i class="fa fa-angle-right"></i></li>
                    <li>GB Meeting</li>
                </ul>
                <div class="sec-title">
                    <h1><span>GB Meeting</span></h1>
                    <p>GHRCACS Pune held its Governing Body Meeting on 20th Jan 2025, addressing key academic,
                        financial, and administrative decisions for institutional growth.
                    </p>

                </div>
            </div>
        </div>
          <div class="breadcrumb-overlay overflow-hidden"
              style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gb-meeting-3.avif);">
          </div>
      </div>
  </section>
  <section class="section-lg">
    <div class="container">
        <div class="sec-title text-center">
            <h2><span>Photo Gallery</span></h2>
        </div>
        <div class="demo-gallery">
          <ul  appLightgallery>
              <li class="grid-item1"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gb-meeting-1.avif"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gb-meeting-1.avif">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gb-meeting-1.avif">
                  </a>
              </li>
              <li class="grid-item2"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gb-meeting-2.avif"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gb-meeting-2.avif">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gb-meeting-2.avif">
                  </a>
              </li>
              <li class="grid-item3 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gb-meeting-3.avif"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gb-meeting-3.avif">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gb-meeting-3.avif">
                  </a>
              </li>
          </ul>
      </div>
    </div>
  </section>
</main>
